









































































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
// import { VueWindowSizePlugin } from 'vue-window-size/option-api';
import { mapState } from 'vuex';
import axios from 'axios';
import { UserState } from '@/store/types';
import auth from '@/libs/auth';
import LogoImage from '@/assets/logo/logo.svg';
import LogoImageAlt from '@/assets/logo/logo-alt.svg';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import hasPermission from '@/libs/permission';
import ChevronIcon from 'mdi-vue/ChevronRight';
import Select from '@/components/Select.vue';
import SidebarItem from './SidebarItem.vue';
import SidebarTree from './SidebarTree.vue';

// Vue.use(VueWindowSizePlugin);

@Component({
  components: {
    SidebarItem,
    SidebarTree,
    ScrollbarWrapper,
    LogoImage,
    LogoImageAlt,
    ChevronIcon,
    Select,
  },
  computed: mapState(['sidebarCollapsed', 'sidebarUpdatedId', 'user']),
})
export default class Sidebar extends Vue {
  option = [
    { value: 'Production', label: 'Production' },
    { value: 'Sandbox', label: 'Sandbox' }]

  missmatch = [{ value: 'Production', label: 'Production' }];
  @Prop({ required: true }) readonly items!: SidebarItemInterface[];

  sandboxDomain = process.env.VUE_APP_SANDBOX_DOMAIN;
  productionDomain = process.env.VUE_APP_PRODUCTION_DOMAIN || '';
  environment = process.env.VUE_APP_ENVIRONMENT || '';
  sidebarItems = [] as SidebarItemInterface[];

  sidebarCollapsed!: boolean;
  sidebarUpdatedId!: number;
  user!: UserState;

  mounted() {
    this.sidebarItems = this.items.filter((e) => hasPermission(e.permission, e.environment, e.isInternal));

    switch (this.environment) {
      case 'production':
        this.missmatch = [{ value: 'Production', label: 'Production' }];
        break;

      case 'sandbox':
        this.missmatch = [{ value: 'Sandbox', label: 'Sandbox' }];
        break;

      default:
    }
    this.ScreenCollapse();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  window = {
    width: 0,
    height: 0,
  }

  handleResize() {
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;
  }

  @Watch('window.width')
  @Watch('$route')
  ScreenCollapse() {
    if (this.window.width < 1024) {
      this.$store.commit('collapse');
    } else {
      this.$store.commit('expand');
    }
  }

  // // eslint-disable-next-line class-methods-use-this
  // get screenCollapse() {
  //   return window.outerWidth < 1024;
  // }

  @Watch('sidebarUpdatedId')
  updateSidebarItems() {
    // console.log('UPDATE SIDEBAR ITEMS');
    this.sidebarItems = this.items.filter((e) => hasPermission(e.permission, e.environment, e.isInternal));
  }

  @Watch('missmatch')
  hmm(dd: any) {
    if (dd !== null) {
      let switchTokenUrl = '';
      let redirect = '';
      const { environment } = this;
      const { origin } = window.location;

      switch (dd.value) {
        case 'Production':
          if (environment !== 'production') {
            switchTokenUrl = process.env.VUE_APP_PROD_API_URL || '';
            const a = this.productionDomain || origin;
            redirect = a;
          }
          break;

        case 'Sandbox':
          if (environment !== 'sandbox') {
            switchTokenUrl = process.env.VUE_APP_SANDBOX_API_URL || '';
            const a = this.sandboxDomain || origin;
            redirect = a;
          }
          break;

        default:
      }

      if (switchTokenUrl !== '') {
        switchTokenUrl += '/switch-token';
        axios.post(switchTokenUrl, {
          // eslint-disable-next-line @typescript-eslint/camelcase
          switch_token: this.$cookies.get('st'),
        }).then((response: any) => {
          auth.clearUser();
          this.$cookies.remove('refresh_token', '/', window.location.hostname);
          // eslint-disable-next-line max-len
          window.location.href = `${redirect}?rt=${response.data.data.refresh_token}&reference=${response.data.data.reference_token}`;
        });
      }
    }
  }
}
